import axios from "./axios";

export async function getApplicationInsightsConnectionString() {
  try {
    const resp = await axios.get(
      `/secrets/applications-insights-connection-string`,
      { skipGlobalErrorHandler: true },
    );
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function getAzureMapsSubscriptionKey() {
  try {
    const resp = await axios.get(`/secrets/azure-maps-subscription-key`);
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
